<template>
  <div class="user-form">
    <div style="max-width: 600px">
      <v-row>
        <v-col cols="12" sm="6">
          <label class="text-field-label">Status</label>
          <v-text-field
            flat
            solo
            readonly
            hide-details="auto"
            class="mt-2"
            v-model="user.idStatus"
          >
            <v-tooltip slot="append" top>
              <template v-slot:activator="{ on }">
                <v-icon :color="user.idStatusColor" v-on="on">{{
                  idStatusIcon
                }}</v-icon>
              </template>
              <span v-if="user.isIdDeclined"
                >Reason: {{ user.ids.decline_reason }}</span
              >
              <span v-else-if="user.isIdPending">Awaiting admin approval</span>
              <span v-else>Veritifcation IDs approved</span>
            </v-tooltip>
          </v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="12">
          <label class="text-field-label">ID / Drivers License</label>
          <div class="mt-2">
            <id-picture :avatar="user.idFront" />
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="12">
          <label class="text-field-label">Headshot</label>
          <div class="mt-2">
            <id-picture :avatar="user.idHeadshot" />
          </div>
        </v-col>
      </v-row>

      <div class="mt-4">
        <v-btn
          color="primary"
          depressed
          class="mr-4 px-6"
          height="40px"
          :disabled="!hasCompleteId || user.isIdVerified"
          :loading="form.$busy"
          @click="showDialog(true)"
          >Approve</v-btn
        >
        <v-btn
          color="red"
          :dark="hasCompleteId && !user.isIdDeclined"
          depressed
          class="mr-4 px-6"
          height="40px"
          :disabled="!hasCompleteId || user.isIdDeclined"
          :loading="form.$busy"
          @click="showDialog(false)"
          >Decline</v-btn
        >
      </div>
    </div>

    <v-dialog v-if="hasCompleteId" v-model="dialog" max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          dialogDecision | capitalize
        }}</v-card-title>

        <v-card-text>
          Are you sure you want to {{ dialogDecision }} the verification IDs?

          <v-row v-if="!approve">
            <v-col>
              <label class="text-field-label">Reason</label>
              <v-textarea
                flat
                solo
                required
                hide-details="auto"
                class="mt-2"
                v-model="form.decline_reason"
                :error-messages="form.$getError('decline_reason')"
                :loading="form.$busy"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn text @click="dialog = false" :loading="form.$busy"
            >Cancel</v-btn
          >

          <v-btn
            text
            :color="dialogColor"
            :loading="form.$busy"
            @click="onSubmit"
            >Confirm</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar.show" right :color="snackbar.color">
      {{ snackbar.message }}
      <v-btn text @click="snackbar.show = false">OK</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import User from '@/models/User'
import { mdiCheck, mdiClose, mdiAlertCircleOutline } from '@mdi/js'
import { mapActions } from 'vuex'
import IdPicture from './IdPicture'
import Form from '@/utils/form'

export default {
  components: {
    IdPicture
  },

  props: {
    user: {
      type: [User, Object]
    }
  },

  computed: {
    request() {
      return this.approve ? this.approveIds : this.declineIds
    },

    dialogDecision() {
      return this.approve ? 'approve' : 'disapprove'
    },

    dialogColor() {
      return this.approve ? 'primary' : 'red'
    },

    idStatusIcon() {
      if (this.user.isIdVerified) return this.icons.check
      if (this.user.isIdDeclined) return this.icons.close
      return this.icons.alert
    },

    hasCompleteId() {
      return !!this.user.idFront && !!this.user.idHeadshot
    }
  },

  data() {
    return {
      icons: {
        check: mdiCheck,
        close: mdiClose,
        alert: mdiAlertCircleOutline
      },
      approve: false,
      dialog: false,
      form: new Form({
        decline_reason: ''
      }),
      snackbar: {
        show: false,
        message: null,
        color: ''
      }
    }
  },

  methods: {
    ...mapActions({
      approveIds: 'user/approveIds',
      declineIds: 'user/declineIds'
    }),

    async onSubmit() {
      if (this.form.$busy) return
      this.form.$setLoading(true)

      await this.request({
        id: this.user.id,
        decline_reason: this.form.decline_reason
      })
        .then(() => {
          this.form.decline_reason = null
          this.form.$setLoading(false)
          this.dialog = false
        })
        .catch(error => {
          this.form.$handleError(error)
          this.form.$setLoading(false)

          this.showSnackbar(this.form.$errorMessage, 'danger')
        })
    },

    showDialog(decision) {
      this.approve = decision
      this.dialog = true
    },

    showSnackbar(message, color) {
      this.snackbar.message = message
      this.snackbar.show = true
      this.snackbar.color = color
    }
  }
}
</script>
